// extracted by mini-css-extract-plugin
export default {"heading":"bF","container":"cF","product_section_row":"eF","carousel":"fF","carouselwide":"gF","carouselwrapper":"hF","blockwrapper":"iF","product_carousel_row":"jF","headingnarrow":"kF","title":"lF"};
    if(module.hot) {
      // 1711394578650
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  